import React from "react";
import { NavLink } from "react-router-dom";
import error from "../../../assets/images/error404/error-1.png";
import "./Page404.css";
const Page404 = () => {
  return (
    <main className="main-content">
      <section className="section-p">
        <div className="page-width">
          <article className="page404">
            <div className="page404__box">
              <figure className="img-404">
                <img src={error} alt="404 Error" />
              </figure>
              <div>
                <h1 className="page404__box-txt1">
                  Uh oh, we couldn't find that!
                </h1>
                <p className="text-ops-rg-16-wt">
                  It seems the page you are looking for does not exist. Please
                  check the URL or return to the homepage.
                </p>
              </div>

              <div className="page404__box__btn">
                <NavLink to="/" target="_self" className="btn-color">
                  Homepage
                </NavLink>
                <NavLink to="/" target="_self" className="btn-not-color">
                  Useful Link
                </NavLink>
              </div>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Page404;
